/*!
 * wmd-custom-dimensions.js
 * Flächenpreis-Konfigurator für WMD-Produkte (Schilder, Plakate, Banner etc.)
 *
 * Statt fester Größenstufen (Format-Dropdown) erhält der Kunde zwei freie
 * Eingabefelder "Breite (cm)" und "Höhe (cm)" mit Min/Max-Validierung.
 *
 * Preisformel (WMD-Logik):
 *   areaWmd   = breite_cm * höhe_cm * base_price_per_sqcm      // WMD-Kosten 1 Stück
 *   wmdTotal  = areaWmd * materialFactor * quantityFactor
 *   shopArea  = roundTo(wmdTotal * markup, round_to)            // markup default 2.8, Rundung 10 Rappen
 *   shopPrice = shopArea + optionDelta                          // zusätzliche Shop-Zuschläge (optional)
 *
 * Konfiguration per Metafeld custom.wmd_custom_dimensions (JSON):
 * {
 *   "enabled": true,
 *   "width_range":  [min, max],          // in cm
 *   "height_range": [min, max],          // in cm
 *   "base_price_per_sqcm": 0.0134,       // WMD-Grundkosten pro cm²
 *   "markup": 2.8,                        // optional, sonst window.__wmdPriceMultiplier oder 2.8
 *   "round_to": 0.10,                     // optional, Rundung Shop-Preis (default 10 Rappen)
 *   "step": 0.5,                          // optional, Eingabe-Schrittweite (default 0.1)
 *   "unit": "cm",                         // optional, Anzeigeeinheit
 *   "default_width":  50,                 // optional, Startwert
 *   "default_height": 30,                 // optional, Startwert
 *   "replace_groups": ["Format","Größe"]  // optional, Options-Gruppen die ausgeblendet werden
 * }
 *
 * ES5-kompatibel (kein Optional Chaining, keine Arrow Functions).
 */
(function () {
  'use strict';

  function num(v, def) {
    var n = Number(v);
    return isFinite(n) ? n : (def === undefined ? 0 : def);
  }

  function roundTo(value, step) {
    step = num(step, 0.05);
    if (step <= 0) return value;
    return Math.round(value / step) * step;
  }

  function chf(v) {
    return 'CHF ' + num(v, 0).toFixed(2);
  }

  /*
   * DIN-A-Formate (Hochformat) in cm – Breite × Höhe.
   * Aufsteigend sortiert (kleinstes zuerst): A5 → A0.
   */
  var DIN_FORMATS = [
    { key: 'A5', width: 14.8, height: 21.0 },
    { key: 'A4', width: 21.0, height: 29.7 },
    { key: 'A3', width: 29.7, height: 42.0 },
    { key: 'A2', width: 42.0, height: 59.4 },
    { key: 'A1', width: 59.4, height: 84.1 },
    { key: 'A0', width: 84.1, height: 118.9 }
  ];

  function WMDCustomDimensions(config) {
    config = config || {};
    this.container = config.container;
    this.cfg = config.dimensions || {};
    this.onChange = typeof config.onChange === 'function' ? config.onChange : function () {};
    this.unit = this.cfg.unit || 'cm';

    this.widthRange = this._range('width_range', 1, 10000);
    this.heightRange = this._range('height_range', 1, 10000);
    this.step = num(this.cfg.step, 0.1) || 0.1;

    this.basePricePerSqcm = num(this.cfg.base_price_per_sqcm, 0);
    this.markup = num(this.cfg.markup, num(window.__wmdPriceMultiplier, 2.8)) || 2.8;
    this.roundStep = num(this.cfg.round_to, 0.05) || 0.05;

    this.widthInput = null;
    this.heightInput = null;
    this.errorEl = null;

    if (this.container) this._render();
  }

  WMDCustomDimensions.prototype._range = function (key, defMin, defMax) {
    var r = this.cfg[key];
    var mn, mx;
    // Format 1: Array [min, max]
    if (Array.isArray(r) && r.length >= 2) {
      mn = num(r[0], defMin);
      mx = num(r[1], defMax);
      if (mx < mn) { var t = mn; mn = mx; mx = t; }
      return { min: mn, max: mx };
    }
    // Format 2: Objekt {min_cm, max_cm} oder {min, max}
    if (r && typeof r === 'object') {
      var rawMin = (r.min_cm !== undefined) ? r.min_cm : r.min;
      var rawMax = (r.max_cm !== undefined) ? r.max_cm : r.max;
      if (rawMin !== undefined || rawMax !== undefined) {
        mn = num(rawMin, defMin);
        mx = num(rawMax, defMax);
        if (mx < mn) { var t2 = mn; mn = mx; mx = t2; }
        return { min: mn, max: mx };
      }
    }
    return { min: defMin, max: defMax };
  };

  WMDCustomDimensions.prototype._makeField = function (labelText, propName, range, defVal) {
    var wrap = document.createElement('div');
    wrap.style.marginBottom = '4px';

    var label = document.createElement('label');
    label.textContent = labelText + ' (' + range.min + '–' + range.max + ' ' + this.unit + ')';
    label.style.cssText = 'display:block;font-weight:700;margin-bottom:6px;font-size:0.95rem;';
    wrap.appendChild(label);

    var input = document.createElement('input');
    input.type = 'number';
    input.name = 'properties[' + propName + ']';
    input.min = String(range.min);
    input.max = String(range.max);
    input.step = String(this.step);
    input.value = (defVal !== null && defVal !== undefined) ? String(defVal) : '';
    input.setAttribute('inputmode', 'decimal');
    input.style.cssText = 'width:100%;padding:10px;border:1px solid #d1d5db;border-radius:8px;font-size:1rem;';

    label.setAttribute('for', ('wmdDim_' + propName).replace(/[^a-zA-Z0-9_]+/g, '_'));
    input.id = ('wmdDim_' + propName).replace(/[^a-zA-Z0-9_]+/g, '_');

    wrap.appendChild(input);
    return { wrap: wrap, input: input };
  };

  WMDCustomDimensions.prototype._render = function () {
    var self = this;
    this.container.innerHTML = '';
    this.container.style.display = '';

    var grid = document.createElement('div');
    grid.style.cssText = 'display:grid;grid-template-columns:1fr 1fr;gap:12px;';

    var defW = (this.cfg.default_width !== undefined && this.cfg.default_width !== null)
      ? num(this.cfg.default_width, this.widthRange.min) : this.widthRange.min;
    var defH = (this.cfg.default_height !== undefined && this.cfg.default_height !== null)
      ? num(this.cfg.default_height, this.heightRange.min) : this.heightRange.min;

    var wField = this._makeField('Breite', 'Breite (cm)', this.widthRange, defW);
    var hField = this._makeField('Höhe', 'Höhe (cm)', this.heightRange, defH);

    this.widthInput = wField.input;
    this.heightInput = hField.input;

    grid.appendChild(wField.wrap);
    grid.appendChild(hField.wrap);
    this.container.appendChild(grid);

    /* ===== DIN-Format-Buttons (A5 … A0) ===== */
    this._renderFormatButtons();

    this.errorEl = document.createElement('div');
    this.errorEl.style.cssText = 'display:none;margin-top:8px;color:#991b1b;background:#fef2f2;border:1px solid #ef4444;border-radius:8px;padding:8px 10px;font-size:0.85rem;';
    this.container.appendChild(this.errorEl);

    var areaInfo = document.createElement('small');
    areaInfo.className = 'wmd-dim-area-info';
    areaInfo.style.cssText = 'display:block;margin-top:6px;color:#6b7280;';
    this.container.appendChild(areaInfo);
    this.areaInfoEl = areaInfo;

    function onInput() {
      self._syncActiveFormat();
      self._validateVisual();
      self.onChange();
    }
    this.widthInput.addEventListener('input', onInput);
    this.heightInput.addEventListener('input', onInput);
    this.widthInput.addEventListener('change', onInput);
    this.heightInput.addEventListener('change', onInput);

    this._syncActiveFormat();
    this._validateVisual();
  };

  /* Prüft, ob ein Format in die konfigurierten Breiten-/Höhen-Bereiche passt. */
  WMDCustomDimensions.prototype._formatFits = function (fmt) {
    return fmt.width >= this.widthRange.min && fmt.width <= this.widthRange.max &&
           fmt.height >= this.heightRange.min && fmt.height <= this.heightRange.max;
  };

  /* Rendert die DIN-Format-Buttongruppe (A5 … A0) unter den Eingabefeldern. */
  WMDCustomDimensions.prototype._renderFormatButtons = function () {
    var self = this;
    var allowFormats = (this.cfg.formats === false) ? false : true;
    if (!allowFormats) return;

    var wrap = document.createElement('div');
    wrap.className = 'wmd-format-group';
    wrap.style.cssText = 'margin-top:12px;';

    var label = document.createElement('div');
    label.className = 'wmd-format-label';
    label.textContent = 'Oder DIN-Format wählen:';
    label.style.cssText = 'font-weight:700;margin-bottom:6px;font-size:0.9rem;';
    wrap.appendChild(label);

    var row = document.createElement('div');
    row.className = 'wmd-format-btns';
    row.style.cssText = 'display:flex;flex-wrap:wrap;gap:8px;';

    this.formatButtons = [];

    for (var i = 0; i < DIN_FORMATS.length; i++) {
      (function (fmt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wmd-format-btn';
        btn.setAttribute('data-format', fmt.key);
        btn.setAttribute('data-width', String(fmt.width));
        btn.setAttribute('data-height', String(fmt.height));
        btn.textContent = fmt.key;
        btn.title = fmt.key + ': ' + fmt.width + ' × ' + fmt.height + ' ' + self.unit;

        var fits = self._formatFits(fmt);
        if (!fits) {
          btn.disabled = true;
          btn.title = fmt.key + ' (' + fmt.width + ' × ' + fmt.height + ' ' + self.unit +
            ') liegt ausserhalb des möglichen Grössenbereichs.';
        }

        // Inline-Fallback-Styling (falls Theme-CSS nicht geladen ist)
        btn.style.cssText = 'padding:8px 14px;border:2px solid #e5e7eb;border-radius:999px;' +
          'background:#fff;color:#111;font:inherit;font-size:.85rem;font-weight:600;cursor:pointer;' +
          'transition:border-color .15s,background .15s;';
        if (btn.disabled) {
          btn.style.opacity = '0.4';
          btn.style.cursor = 'not-allowed';
        }

        btn.addEventListener('click', function (e) {
          e.preventDefault();
          if (btn.disabled) return;
          self.setDimensions(fmt.width, fmt.height);
        });

        row.appendChild(btn);
        self.formatButtons.push(btn);
      })(DIN_FORMATS[i]);
    }

    wrap.appendChild(row);
    this.container.appendChild(wrap);
  };

  /*
   * Setzt Breite/Höhe programmatisch, aktualisiert die Markierung,
   * validiert und triggert die Preisberechnung (onChange).
   */
  WMDCustomDimensions.prototype.setDimensions = function (width, height) {
    if (this.widthInput) this.widthInput.value = String(width);
    if (this.heightInput) this.heightInput.value = String(height);
    this._syncActiveFormat();
    this._validateVisual();
    this.onChange();
  };

  /* Markiert den Format-Button, dessen Maße den aktuellen Feldwerten entsprechen. */
  WMDCustomDimensions.prototype._syncActiveFormat = function () {
    if (!this.formatButtons) return;
    var w = this.widthInput ? num(this.widthInput.value, NaN) : NaN;
    var h = this.heightInput ? num(this.heightInput.value, NaN) : NaN;
    var tol = 0.05; // cm Toleranz
    for (var i = 0; i < this.formatButtons.length; i++) {
      var btn = this.formatButtons[i];
      var bw = num(btn.getAttribute('data-width'), NaN);
      var bh = num(btn.getAttribute('data-height'), NaN);
      var match = isFinite(w) && isFinite(h) &&
                  Math.abs(bw - w) <= tol && Math.abs(bh - h) <= tol;
      if (match) {
        btn.classList.add('is-active');
        if (!btn.disabled) {
          btn.style.borderColor = '#c9a227';
          btn.style.background = '#fdf8e7';
        }
      } else {
        btn.classList.remove('is-active');
        if (!btn.disabled) {
          btn.style.borderColor = '#e5e7eb';
          btn.style.background = '#fff';
        }
      }
    }
  };

  WMDCustomDimensions.prototype.getDimensions = function () {
    var w = num(this.widthInput ? this.widthInput.value : NaN, NaN);
    var h = num(this.heightInput ? this.heightInput.value : NaN, NaN);
    var wEmpty = !this.widthInput || this.widthInput.value === '';
    var hEmpty = !this.heightInput || this.heightInput.value === '';

    if (wEmpty || hEmpty || !isFinite(w) || !isFinite(h)) {
      return { valid: false, error: 'Bitte Breite und Höhe eingeben.', width: w, height: h };
    }
    if (w < this.widthRange.min || w > this.widthRange.max) {
      return { valid: false, error: 'Breite muss zwischen ' + this.widthRange.min + ' und ' + this.widthRange.max + ' ' + this.unit + ' liegen.', width: w, height: h };
    }
    if (h < this.heightRange.min || h > this.heightRange.max) {
      return { valid: false, error: 'Höhe muss zwischen ' + this.heightRange.min + ' und ' + this.heightRange.max + ' ' + this.unit + ' liegen.', width: w, height: h };
    }
    return { valid: true, error: '', width: w, height: h };
  };

  WMDCustomDimensions.prototype._validateVisual = function () {
    var d = this.getDimensions();
    var hasInput = (this.widthInput && this.widthInput.value !== '') || (this.heightInput && this.heightInput.value !== '');
    if (!d.valid && hasInput && this.errorEl) {
      this.errorEl.textContent = d.error;
      this.errorEl.style.display = '';
    } else if (this.errorEl) {
      this.errorEl.style.display = 'none';
    }
    if (this.areaInfoEl) {
      if (d.valid) {
        var area = d.width * d.height;
        this.areaInfoEl.textContent = 'Fläche: ' + d.width + ' × ' + d.height + ' ' + this.unit + ' = ' + area.toFixed(1) + ' cm²';
      } else {
        this.areaInfoEl.textContent = '';
      }
    }
    return d.valid;
  };

  /**
   * Berechnet den Shop-Preis für die aktuelle Fläche.
   * opts = { materialFactor, quantityFactor, optionDelta, markup }
   * Rückgabe: { valid, error, shopPrice, wmdPrice, area, width, height }
   */
  WMDCustomDimensions.prototype.computePrice = function (opts) {
    opts = opts || {};
    var d = this.getDimensions();
    if (!d.valid) {
      return { valid: false, error: d.error, shopPrice: 0, wmdPrice: 0, area: 0 };
    }

    var area = d.width * d.height;
    var materialFactor = num(opts.materialFactor, 1) || 1;
    var quantityFactor = num(opts.quantityFactor, 1) || 1;
    var optionDelta = num(opts.optionDelta, 0);
    var markup = num(opts.markup, this.markup) || this.markup;

    var wmdTotal = area * this.basePricePerSqcm * materialFactor * quantityFactor;
    var shopArea = roundTo(wmdTotal * markup, this.roundStep);
    var shopPrice = shopArea + optionDelta;
    if (shopPrice < 0) shopPrice = 0;

    return {
      valid: true,
      error: '',
      shopPrice: shopPrice,
      wmdPrice: wmdTotal,
      area: area,
      width: d.width,
      height: d.height,
      markup: markup
    };
  };

  WMDCustomDimensions.prototype.isValid = function () {
    return this.getDimensions().valid;
  };

  WMDCustomDimensions.prototype.getSummary = function () {
    var d = this.getDimensions();
    if (!d.valid) return '';
    return d.width + ' × ' + d.height + ' ' + this.unit;
  };

  // Hilfsfunktionen auch extern verfügbar machen
  WMDCustomDimensions.roundTo = roundTo;
  WMDCustomDimensions.chf = chf;

  window.WMDCustomDimensions = WMDCustomDimensions;
})();
